import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SabisInput2Component, SabisNgxDatepickerComponent, SabisNgxIconsModule, SDPTranslateModule } from '../public-api';
import { SabisButton2Component } from './sabis-button2/sabis-button2.component';
import { SabisNgxCheckboxComponent } from './sabis-checkbox/checkbox.component';
import { SabisComboBox2Component } from './sabis-combobox/combobox.component';
import { SabisTextArea2Component } from './sabis-textarea2/text-area.component';
import { SabisNgxAccordionComponent } from './sabis-accordion/sabis-accordion.component';
import { SabisTreeComboboxComponent } from './sabis-tree-combobox/sabis-tree-combobox.component';
import { SelectAllDirective } from './sabis-combobox/select-all.directive';



@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    SDPTranslateModule,
    SabisNgxIconsModule,

    MatSelectModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    MatAutocompleteModule
  ],
  exports: [
    SabisButton2Component,
    SabisInput2Component,
    SabisComboBox2Component,
    SabisTextArea2Component,
    SabisNgxCheckboxComponent,
    SabisNgxDatepickerComponent,
    SabisNgxAccordionComponent,
    SabisTreeComboboxComponent
  ],
  declarations: [
    SabisButton2Component,
    SabisInput2Component,
    SabisComboBox2Component,
    SabisTextArea2Component,
    SabisNgxCheckboxComponent,
    SabisNgxDatepickerComponent,
    SabisNgxAccordionComponent,
    SabisTreeComboboxComponent,
    SelectAllDirective
  ]
})
export class SabisComponents2Module {

}
